import { lazy } from "react";

const routes = [
  {
    path: "/seller_product_variant",
    element: lazy(() => import("../pages/SellerProductVariant")),
  },
  {
    path: "/online_seller_product_variant",
    element: lazy(() => import("../pages/SellerProductVariant/online")),
  },
];

export default routes;
